import React from 'react';

const EDocsLogo = () => {
	return (
		<img src={`${process.env.PUBLIC_URL}/edocuments-logo.png`} alt="eDocuments Logo" />
	);
};

export default EDocsLogo;